export enum EventSort {
  StartsAt = 'starts_at',
  Name = 'name',
}
